import $ from 'jquery';
import BaseController from './BaseController';

class MiniCartController extends BaseController {

    initialize() {
        this.actions.addAction('fragments_changed', this.onFragmentsChanged.bind(this));
        this.actions.addAction('mini_cart_ready', this.onMiniCartReady.bind(this));
        this.actions.addAction('mini_cart_updated', this.onMiniCartReady.bind(this));
        super.initialize();
    }

    onFragmentsChanged() {
        if (!this.cart.isEmpty()) {
            super.initialize();
        }
    }

    onMiniCartReady() {
        super.initialize();
    }

    onPaymentElementReady() {
        super.onPaymentElementReady();
        $(this.getElementContainer()).show();
    }

    getElementContainer() {
        const el = document.querySelectorAll(`.wc-ppcp-minicart-${this.id}`);
        if (el && el.length > 0) {
            return el;
        }
        $('.woocommerce-mini-cart__buttons').append(`<a id="wc-ppcp-minicart-${this.id}"></a>`);
        return document.getElementById(`wc-ppcp-minicart-${this.id}`);
    }
}

export default MiniCartController;
export {MiniCartController};